const rankingItems = [
  { rank: 1, title: '某顶流艺人被拍到深夜密会，工作室火速发声明否认', heat: '热度 258万', change: 'up' },
  { rank: 2, title: '知名品牌被曝原材料造假，官方调查结果即将公布', heat: '热度 213万', change: 'up' },
  { rank: 3, title: '热门综艺节目录制现场发生意外，节目组紧急回应', heat: '热度 187万', change: 'new' },
  { rank: 4, title: '某上市公司CEO突然宣布辞职，股价盘中大幅波动', heat: '热度 154万', change: 'down' },
  { rank: 5, title: '年度网络流行语评选结果出炉，吃瓜群众情绪高涨', heat: '热度 129万', change: 'up' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          热度榜单
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14 max-w-lg mx-auto">
          实时更新的吃瓜热度排行榜，看看大家都在讨论什么
        </p>
        <div className="max-w-3xl mx-auto">
          {rankingItems.map((item, idx) => (
            <div
              key={idx}
              className="flex items-center gap-4 p-4 md:p-5 border-b border-background-200/60 last:border-b-0 hover:bg-background-50 transition-colors cursor-pointer group"
            >
              <div className={`w-9 h-9 flex items-center justify-center rounded-lg font-bold text-sm flex-shrink-0 ${
                item.rank === 1 ? 'bg-primary-500 text-background-50' :
                item.rank === 2 ? 'bg-accent-500 text-background-50' :
                item.rank === 3 ? 'bg-accent-400 text-background-50' :
                'bg-secondary-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm md:text-base font-medium text-foreground-800 group-hover:text-primary-500 transition-colors truncate">
                  {item.title}
                </p>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <span className="text-xs text-foreground-400 whitespace-nowrap">{item.heat}</span>
                <span className="w-4 h-4 flex items-center justify-center">
                  {item.change === 'up' && <i className="ri-arrow-up-line text-green-500 text-sm"></i>}
                  {item.change === 'down' && <i className="ri-arrow-down-line text-red-500 text-sm"></i>}
                  {item.change === 'new' && <i className="ri-sparkling-line text-accent-500 text-sm"></i>}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}